/**
 * RPC 授权中间件【声明】：实现层在 @crm/rpc-contract/access/middleware-impl。
 * 契约层持有类声明，RpcGroup.middleware 挂载用。
 */
import type { CurrentPermissions, CurrentUser } from "./access/services";
import * as RpcMiddleware from "effect/unstable/rpc/RpcMiddleware";
import { RpcAppError } from "./errors";

export class RpcAuthMiddleware extends RpcMiddleware.Service<
  RpcAuthMiddleware,
  { provides: CurrentUser | CurrentPermissions }
>()("@crm/rpc/AuthMiddleware", { error: RpcAppError }) {}
